<template>
  <div v-if="!loading" class="" style="min-height: 650px; height: 100%">
    <iframe
        v-if="cpNum == 'fe559562bb2b456b848a545bb5d2eb4a' || cpNum == 'ee7a45afdd0540d59efc25eb7f3bde74'"
        frameborder="0"
        height="100%"
        src="https://www.qutgroup.com/fcweb/demo"
        width="100%"
    ></iframe>
  </div>
</template>
<script>
import {getsmoke} from "../../api/facility";

export default {
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  props: ["cpNum"],
  created() {
    this.getList();
  },
  mounted() {
    // this.getList()
    setTimeout(() => {
      var head = document.getElementsByTagName("head")[0];
      var meta = document.createElement("meta");
      meta.httpEquiv = "Content-Security-Policy";
      meta.content = "upgrade-insecure-requests";
      meta.id = "bimHttp";
      head.appendChild(meta);
      this.loading = false;
    });
  },
  watch: {
    cpNum() {
      this.getList();
    },
    loading(v) {
      if (!v) {
        this.getList();
      }
    },
  },
  beforeDestroy() {
    var meta = document.getElementById("bimHttp");

    // document.head.removeChild(meta)
    meta.parentNode.removeChild(meta);
  },
  methods: {
    getList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "fe559562bb2b456b848a545bb5d2eb4a  " : this.cpNum;

      if (
          !(
              this.cpNum == "fe559562bb2b456b848a545bb5d2eb4a" ||
              this.$store.state.user.company.cCompanyNum == "fe559562bb2b456b848a545bb5d2eb4a" ||
              this.cpNum == "ae5d8c2a5ed7470c8b08fafa1524dfce" ||
              this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ||
              this.$store.state.user.company.cCompanyNum == "ae5d8c2a5ed7470c8b08fafa1524dfce" ||
              this.$store.state.user.company.cCompanyNum == "ee7a45afdd0540d59efc25eb7f3bde74"
          )
      ) {
        this.$message.warning("该业务尚未开通，请联系管理员");
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
